package org.moxultimate.topwithmox.product.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * ProductResponse
 * Maps a single product row returned by GET /product-contents.
 * All optional fields are nullable so the JSON parser tolerates missing values.
 */
@Serializable
data class ProductResponse(
    @SerialName("id") val id: Long,
    @SerialName("contentId") val contentId: Long,
    @SerialName("brand") val brand: String? = null,
    @SerialName("name") val name: String? = null,
    @SerialName("label") val label: String? = null,
    @SerialName("description") val description: String? = null,
    @SerialName("pros") val pros: String? = null,
    @SerialName("cons") val cons: String? = null,
    @SerialName("imagePath") val imagePath: String? = null,
    @SerialName("shopeeLink") val shopeeLink: String? = null,
    @SerialName("shopeePrice") val shopeePrice: String? = null,
    @SerialName("shopeePromo") val shopeePromo: String? = null,
    @SerialName("lazadaLink") val lazadaLink: String? = null,
    @SerialName("lazadaPrice") val lazadaPrice: String? = null,
    @SerialName("lazadaPromo") val lazadaPromo: String? = null,
    @SerialName("amazonLink") val amazonLink: String? = null,
    @SerialName("amazonPrice") val amazonPrice: String? = null,
    @SerialName("amazonPromo") val amazonPromo: String? = null,
    @SerialName("tiktokLink") val tiktokLink: String? = null,
    @SerialName("tiktokPrice") val tiktokPrice: String? = null,
    @SerialName("tiktokPromo") val tiktokPromo: String? = null,
    @SerialName("createdAt") val createdAt: String? = null,
)
